'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DataTHead: ()=>DataTHead
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const react_table_namespaceObject = require("@tanstack/react-table");
const external_react_namespaceObject = require("react");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const index_cjs_namespaceObject = require("../Checkbox/index.cjs");
const external_Table_index_cjs_namespaceObject = require("../Table/index.cjs");
const external_DataTable_variants_cjs_namespaceObject = require("./DataTable.variants.cjs");
const DataTHead = ({ table })=>{
    const handleSelectAll = (0, external_react_namespaceObject.useCallback)((_value, e)=>{
        table.getToggleAllRowsSelectedHandler()(e);
    }, [
        table
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Table_index_cjs_namespaceObject.THead, {
        children: table.getHeaderGroups().map((headerGroup)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Table_index_cjs_namespaceObject.Tr, {
                children: [
                    table.options.enableMultiRowSelection && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Table_index_cjs_namespaceObject.Th, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Checkbox, {
                            checked: table.getIsAllRowsSelected(),
                            indeterminate: table.getIsSomeRowsSelected(),
                            disabled: !table.options.enableMultiRowSelection,
                            handleChange: handleSelectAll,
                            "aria-label": "Select all",
                            value: headerGroup.id,
                            name: headerGroup.id
                        })
                    }, `${headerGroup.id}-thead-checkbox`),
                    headerGroup.headers.map((header)=>{
                        const resize = Boolean(header.column.columnDef.enableResizing || table.options.enableColumnResizing);
                        const isResizing = header.column.getIsResizing();
                        const { cell: cellClass, resizer: resizerClass } = (0, external_DataTable_variants_cjs_namespaceObject.mobileVariants)({
                            resize,
                            isResizing,
                            ...header.column.columnDef.meta?.mobile
                        });
                        const cellProps = header.column.columnDef.meta?.cellProps || {};
                        const getSortType = ()=>{
                            if (!header.column.getCanSort()) return 'disabled';
                            switch(header.column.getIsSorted()){
                                case 'asc':
                                    return 'ascending';
                                case 'desc':
                                    return 'descending';
                                default:
                                    return 'unsorted';
                            }
                        };
                        return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_Table_index_cjs_namespaceObject.Th, {
                            className: (0, cn_cjs_namespaceObject.cn)(cellClass(), 'relative', `${headerGroup.id}-thead-${header.id}-th`),
                            ...cellProps,
                            style: {
                                minWidth: `var(--header-${header?.id}-size)`
                            },
                            onClick: header.column.getToggleSortingHandler(),
                            sort: getSortType(),
                            children: [
                                !header.isPlaceholder && (0, react_table_namespaceObject.flexRender)(header.column.columnDef.header, header.getContext()),
                                resize && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                    "data-testid": "resize",
                                    role: "separator",
                                    onDoubleClick: ()=>header.column.resetSize(),
                                    onMouseDown: header.getResizeHandler(),
                                    onTouchStart: header.getResizeHandler(),
                                    className: resizerClass()
                                })
                            ]
                        }, `${headerGroup.id}-thead-${header.id}-th`);
                    })
                ]
            }, `${headerGroup.id}-thead-tr`))
    });
};
exports.DataTHead = __webpack_exports__.DataTHead;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DataTHead"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
